import { render, staticRenderFns } from "./P05.vue?vue&type=template&id=635398e4&scoped=true"
import script from "./P05.vue?vue&type=script&lang=js"
export * from "./P05.vue?vue&type=script&lang=js"
import style0 from "./P05.vue?vue&type=style&index=0&id=635398e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635398e4",
  null
  
)

export default component.exports